import { StyledAppError } from "./index.styled";
import PropTypes from "prop-types";
import { Space, Typography } from "antd";
import AppLottie from "_lib/AppLottie";
import animatedGhostData from "_assets/lottie/lib/ghost.json";
import ContainerButton from "_lib/ContainerButton";
import { hardRefreshAndEmptyCache } from "_helpers";

const AppError = (props) => {
  const { description, showRefreshButton = false, noContent = true } = props;

  return (
    <StyledAppError
      image={
        <AppLottie
          className="lottie-not-found"
          animationData={animatedGhostData}
          loop={true}
          size={200}
        />
      }
      description={
        <Space direction="vertical">
          <Title level={4}>
            {noContent ? "Nothing here 😔" : "Looks cold in here"}
          </Title>
          {description && <Text>{description}</Text>}
          {showRefreshButton && (
            <ContainerButton
              title="Refresh"
              type="primary"
              onClick={hardRefreshAndEmptyCache}
              size="large"
            />
          )}
        </Space>
      }
    />
  );
};

const { Title, Text } = Typography;

AppError.propTypes = {
  description: PropTypes.string,
  noContent: PropTypes.bool,
  showRefreshButton: PropTypes.bool,
};

export default AppError;
